import React from 'react';
import { WifiIcon, ScanLineIcon, CheckCircleIcon, SmartphoneIcon, BellIcon, CloudIcon } from 'lucide-react';
export function SetupGuide() {
  return <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-350">
      <h2 className="text-xl font-semibold mb-6" data-id="element-351">Device Setup Guide</h2>
      <div className="max-w-3xl mx-auto" data-id="element-352">
        <div className="flex items-center mb-8" data-id="element-353">
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold" data-id="element-354">
            1
          </div>
          <div className="h-0.5 flex-1 bg-blue-200 mx-2" data-id="element-355"></div>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold" data-id="element-356">
            2
          </div>
          <div className="h-0.5 flex-1 bg-gray-200 mx-2" data-id="element-357"></div>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold" data-id="element-358">
            3
          </div>
          <div className="h-0.5 flex-1 bg-gray-200 mx-2" data-id="element-359"></div>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-bold" data-id="element-360">
            4
          </div>
        </div>
        <div className="bg-blue-50 rounded-xl p-6 mb-8" data-id="element-361">
          <h3 className="text-lg font-medium mb-4 flex items-center" data-id="element-362">
            <WifiIcon className="mr-2 text-blue-600" size={20} data-id="element-363" />
            Connect to Wi-Fi
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-364">
            <div data-id="element-365">
              <ol className="space-y-4" data-id="element-366">
                <li className="flex items-start" data-id="element-367">
                  <span className="bg-blue-100 text-blue-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-368">
                    1
                  </span>
                  <p className="text-gray-700" data-id="element-369">
                    Plug in your Home Monitor to a power outlet using the
                    included USB-C cable and adapter.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-370">
                  <span className="bg-blue-100 text-blue-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-371">
                    2
                  </span>
                  <p className="text-gray-700" data-id="element-372">
                    Wait for the LED indicator to flash blue, indicating it's in
                    setup mode.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-373">
                  <span className="bg-blue-100 text-blue-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-374">
                    3
                  </span>
                  <p className="text-gray-700" data-id="element-375">
                    Open your smartphone's Wi-Fi settings and connect to the
                    "HomeMonitor-Setup" network.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-376">
                  <span className="bg-blue-100 text-blue-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-377">
                    4
                  </span>
                  <p className="text-gray-700" data-id="element-378">
                    Return to the app and follow the on-screen instructions to
                    connect the device to your home Wi-Fi network.
                  </p>
                </li>
              </ol>
            </div>
            <div className="flex items-center justify-center" data-id="element-379">
              <div className="bg-white p-6 rounded-xl shadow-sm max-w-[200px]" data-id="element-380">
                <div className="aspect-square bg-gray-100 rounded-lg flex flex-col items-center justify-center p-4 mb-4" data-id="element-381">
                  <div className="w-16 h-16 bg-blue-500 rounded-lg mb-2 flex items-center justify-center" data-id="element-382">
                    <WifiIcon className="text-white" size={32} data-id="element-383" />
                  </div>
                  <div className="animate-pulse flex space-x-1 mt-2" data-id="element-384">
                    <div className="w-2 h-2 bg-blue-500 rounded-full" data-id="element-385"></div>
                    <div className="w-2 h-2 bg-blue-300 rounded-full" data-id="element-386"></div>
                    <div className="w-2 h-2 bg-blue-300 rounded-full" data-id="element-387"></div>
                  </div>
                </div>
                <p className="text-center text-sm text-gray-600" data-id="element-388">
                  Device in setup mode
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-6 mb-8" data-id="element-389">
          <h3 className="text-lg font-medium mb-4 flex items-center" data-id="element-390">
            <ScanLineIcon className="mr-2 text-gray-600" size={20} data-id="element-391" />
            Scan QR Code
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-392">
            <div data-id="element-393">
              <p className="text-gray-600 mb-4" data-id="element-394">
                Once your Home Monitor is connected to Wi-Fi, you'll need to
                pair it with your account using the QR code.
              </p>
              <ol className="space-y-4" data-id="element-395">
                <li className="flex items-start" data-id="element-396">
                  <span className="bg-gray-200 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-397">
                    1
                  </span>
                  <p className="text-gray-700" data-id="element-398">
                    Tap "Scan QR Code" in the app.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-399">
                  <span className="bg-gray-200 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-400">
                    2
                  </span>
                  <p className="text-gray-700" data-id="element-401">
                    Point your camera at the QR code on the bottom of the Home
                    Monitor.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-402">
                  <span className="bg-gray-200 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-403">
                    3
                  </span>
                  <p className="text-gray-700" data-id="element-404">
                    The app will automatically register and link the device to
                    your account.
                  </p>
                </li>
              </ol>
            </div>
            <div className="flex items-center justify-center" data-id="element-405">
              <div className="bg-white p-4 rounded-xl shadow-sm" data-id="element-406">
                <div className="w-48 h-48 bg-gray-900 rounded-lg flex items-center justify-center" data-id="element-407">
                  <div className="w-36 h-36 bg-white grid grid-cols-3 grid-rows-3 p-2" data-id="element-408">
                    <div className="bg-black rounded-lg m-1" data-id="element-409"></div>
                    <div className="m-1" data-id="element-410"></div>
                    <div className="bg-black rounded-lg m-1" data-id="element-411"></div>
                    <div className="m-1" data-id="element-412"></div>
                    <div className="bg-black rounded-lg m-1" data-id="element-413"></div>
                    <div className="m-1" data-id="element-414"></div>
                    <div className="bg-black rounded-lg m-1" data-id="element-415"></div>
                    <div className="m-1" data-id="element-416"></div>
                    <div className="bg-black rounded-lg m-1" data-id="element-417"></div>
                  </div>
                </div>
                <p className="text-center text-sm text-gray-600 mt-2" data-id="element-418">
                  Device QR Code
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-419">
          <div className="bg-gray-50 rounded-xl p-6" data-id="element-420">
            <h3 className="text-lg font-medium mb-4 flex items-center" data-id="element-421">
              <SmartphoneIcon className="mr-2 text-gray-600" size={20} data-id="element-422" />
              Configure Device
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-423">
              Set up your preferences and configure the Home Monitor:
            </p>
            <ul className="space-y-3" data-id="element-424">
              <li className="flex items-center" data-id="element-425">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-426" />
                <span className="text-gray-700" data-id="element-427">Name your device</span>
              </li>
              <li className="flex items-center" data-id="element-428">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-429" />
                <span className="text-gray-700" data-id="element-430">Select your location</span>
              </li>
              <li className="flex items-center" data-id="element-431">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-432" />
                <span className="text-gray-700" data-id="element-433">Set energy budget alerts</span>
              </li>
              <li className="flex items-center" data-id="element-434">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-435" />
                <span className="text-gray-700" data-id="element-436">Configure time zone</span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 rounded-xl p-6" data-id="element-437">
            <h3 className="text-lg font-medium mb-4 flex items-center" data-id="element-438">
              <BellIcon className="mr-2 text-gray-600" size={20} data-id="element-439" />
              Set Up Notifications
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-440">
              Choose which alerts you want to receive:
            </p>
            <ul className="space-y-3" data-id="element-441">
              <li className="flex items-center" data-id="element-442">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-443" />
                <span className="text-gray-700" data-id="element-444">Energy usage alerts</span>
              </li>
              <li className="flex items-center" data-id="element-445">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-446" />
                <span className="text-gray-700" data-id="element-447">Device connection status</span>
              </li>
              <li className="flex items-center" data-id="element-448">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-449" />
                <span className="text-gray-700" data-id="element-450">Bill Guard warnings</span>
              </li>
              <li className="flex items-center" data-id="element-451">
                <CheckCircleIcon size={16} className="text-gray-400 mr-2" data-id="element-452" />
                <span className="text-gray-700" data-id="element-453">
                  Firmware update notifications
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-454">
          <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-455">
            Start Setup Process
          </button>
        </div>
      </div>
    </div>;
}